const initialState = () => ({
  isOpened: false,
  padItem: {},
  onSuccessCallback: null,
  modalData: {
    title: '',
    description: '',
    confirmationTerm: ''
  }
});

const ACTION_KEY = 'PAD_CREATOR_EQUIPMENT_CONFIRMATION_MODAL';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_OPEN`: {
      const { padItem, modalData, onSuccessCallback } = action.payload;

      return {
        ...state,
        isOpened: true,
        padItem,
        modalData,
        onSuccessCallback
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
